module.exports = __webpack_public_path__ + "img/SPPG.03c85816.svg";